import React from 'react'

import { makeStyles } from 'tss-react/mui'
import { RouteContentSkeleton } from '../Skeletons'

const useStyles = makeStyles()(theme => ({
  root: {
    minHeight: '100vh',
  },
}))

interface Props {
  dataQa?: string
}

/**
 * returns skeleton for route content
 */
const SuspenseContentFallback: React.FC<Props> = ({ dataQa }) => {
  const { classes } = useStyles()

  return (
    <div className={classes.root} data-qa={dataQa}>
      <RouteContentSkeleton />
    </div>
  )
}

export default SuspenseContentFallback
